module.exports = {
  CLIMATE_PLEDGE_RATINGS_FAQ: 'https://ecosia.helpscoutdocs.com/article/368-climate-pledge-rating',
  FACEBOOK_SHARE_URL: 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.ecosia.org&ref=share',
  FACEBOOK: 'https://www.facebook.com/ecosia',
  FAQ: 'https://ecosia.helpscoutdocs.com/',
  HELP: 'https://ecosia.helpscoutdocs.com/',
  GIFTING_TREES: 'https://plant.ecosia.org',
  GREEN_SEARCH: 'https://blog.ecosia.org/green-search/',
  GREEN_SEARCH_FR: 'https://fr.blog.ecosia.org/recherche-verte/',
  GREEN_SEARCH_DE: 'https://de.blog.ecosia.org/grune-suche/',
  INSTAGRAM: 'https://www.instagram.com/ecosia',
  JOBS: 'https://explore.ecosia.org/jobs',
  LINKEDIN: 'https://www.linkedin.com/company/ecosia',
  MICROSOFT_PRIVACY: 'https://privacy.microsoft.com/privacystatement',
  MENTAL_HEALTH_UK_FOOTER: 'https://www.samaritans.org',
  MENTAL_HEALTH_UK: 'https://www.samaritans.org/how-we-can-help/contact-samaritan/',
  MENTAL_HEALTH_DE: 'https://www.telefonseelsorge.de/',
  MENTAL_HEALTH_AT: 'https://www.telefonseelsorge.at/home',
  MENTAL_HEALTH_CH: 'https://www.143.ch/',
  MYIP_HELPCENTER: 'https://ecosia.helpscoutdocs.com/article/377-ip-addresses',
  // The shop is currently in maintenance
  // we want to disable the link to it temporarly
  // https://ecosia.atlassian.net/browse/ENGT-757
  // SHOP: 'https://ecosia.teemill.com',
  TERMS_OF_SERVICE: 'https://explore.ecosia.org/ecosia-search-tos',
  TREEDAY_URL: 'https://www.treeday.net/search',
  TIKTOK: 'https://www.tiktok.com/@ecosia',
  TWITTER: 'https://twitter.com/ecosia',
  YOUTUBE: 'https://www.youtube.com/user/EcosiaORG',
  HELPSCOUT_GUIDE_TO_GREENER_SEARCH: 'https://blog.ecosia.org/green-search/',
  HELPSCOUT_LEARN_MORE_SYNC_COUNTER: 'https://ecosia.helpscoutdocs.com/article/351-sync-your-counter-across-devices',
  HELPSCOUT_PERSONALIZED_SEARCH: 'https://ecosia.helpscoutdocs.com/article/48-what-are-personalized-search-results',
  HELPSCOUT_PERSONALIZED_ADS_LEARNMORE_LINK: 'https://ecosia.helpscoutdocs.com/article/366-personalized-advertisement',
  HELPSCOUT_AD_LEARN_MORE_URL: 'https://ecosia.helpscoutdocs.com/article/30-how-does-ecosia-use-profits-from-ad-income-to-finance-tree-planting',
  HELPSCOUT_AD_BLOCKING: 'https://ecosia.helpscoutdocs.com/article/397-ads-on-ecosia',
  HELPSCOUT_ADVERTISE_ON_ECOSIA: 'https://ecosia.helpscoutdocs.com/article/108-how-to-advertise-on-ecosia',
  HELPSCOUT_CONTACT_US: 'https://ecosia.helpscoutdocs.com/article/364-contact-us',
  HELPSCOUT_SEARCH_SHORTCUTS: 'https://ecosia.helpscoutdocs.com/article/22-shortcuts',
  TRANSPARENCY_LAW: 'https://ecosia.helpscoutdocs.com/article/403-wie-ecosia-ihre-inhalte-einordnet',
};
